import React from 'react';
import { CheckCircleIcon, ChevronRightIcon } from 'lucide-react';
export function PhaseSummary({
  phaseName,
  summary,
  onSubmit
}) {
  return <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-245">
      <div className="flex items-center justify-center mb-6" data-id="element-246">
        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-247">
          <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-248" />
        </div>
      </div>
      <h2 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-249">
        {phaseName} Completed!
      </h2>
      <p className="text-center text-gray-600 mb-6" data-id="element-250">
        Here's a summary of what your team accomplished in this phase.
      </p>
      <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 mb-6" data-id="element-251">
        <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-252">
          Phase Summary
        </h3>
        <div className="prose prose-sm max-w-none" data-id="element-253">
          {summary.split('\n').map((line, index) => {
          if (line.startsWith('## ')) {
            return <h2 key={index} className="text-xl font-bold mt-4 mb-2" data-id="element-254">
                  {line.replace('## ', '')}
                </h2>;
          } else if (line.startsWith('### ')) {
            return <h3 key={index} className="text-lg font-semibold mt-3 mb-1" data-id="element-255">
                  {line.replace('### ', '')}
                </h3>;
          } else if (line.startsWith('**') && line.endsWith('**')) {
            return <p key={index} className="font-bold my-1" data-id="element-256">
                  {line.replace(/^\*\*|\*\*$/g, '')}
                </p>;
          } else if (line.startsWith('- ')) {
            return <div key={index} className="flex items-start my-1" data-id="element-257">
                  <span className="text-indigo-600 mr-2" data-id="element-258">•</span>
                  <span data-id="element-259">{line.replace('- ', '')}</span>
                </div>;
          } else if (line.trim() === '') {
            return <div key={index} className="h-2" data-id="element-260"></div>;
          } else {
            return <p key={index} className="my-1" data-id="element-261">
                  {line}
                </p>;
          }
        })}
        </div>
      </div>
      <div className="flex justify-center" data-id="element-262">
        <button className="px-6 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition flex items-center" onClick={onSubmit} data-id="element-263">
          Continue to Next Phase
          <ChevronRightIcon className="w-4 h-4 ml-2" data-id="element-264" />
        </button>
      </div>
    </div>;
}